import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import ProfileInfo from "../../../Layouts/ProfileInfo";
import Footer from "../../../Layouts/Footer";

import "./Sidebar.css";
const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [openPromoInst, setOpenPromoInst] = useState(false);

  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/audition-admin/");

  // const [open2, setOpen2] = useState(false);
  const history = useHistory();

  const [instruction, setInstruction] = useState(false);

  return (
    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
      <div className="sb-sidenav-menu custom-nav-scroll">
        <div className="nav">
          <ProfileInfo />

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Core{" "}
          </div>

          <Link
            className={
              url[1] === "dashboard" ? "nav-link active-nav" : "nav-link"
            }
            to="/audition-admin/dashboard"
          >
            <span className="">
              <i className="fas fa-tachometer-alt"></i> &nbsp; Dashboard
            </span>
          </Link>
          <div
            className="nav-link cursor-pointer"
            onClick={() => setOpen(!open)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
          >
            <div className="">
              <i className="fa-regular fa-calendar-check"></i> &nbsp;
            </div>
            &nbsp;Audition
            {open ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>

          <Collapse in={open}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "audition/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/dashboard"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp;
                </div>
                Dashboard
              </Link>

              <Link
                className={
                  url[1] === "audition/event"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/event"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                Events
              </Link>

              <Link
                className={
                  url[1] === "audition/create-post"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/create-post"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                Create Post
              </Link>

              <Link
                className={
                  url[1] === "audition/post-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/post-list"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                Post List
              </Link>

              {/* <div className="accordion-item">
                <div className="accordion-header" id="headingThree">
                  <button
                    className="px-3 py-2 accordion-button collapsed btnAdminnav"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <i className="fa-solid fa-atom"></i>  &nbsp; Promo
                    Instruction
                  </button>
                </div>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse  bg_black"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/audition/promo-list"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    List
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/promo/create"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Create
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/promo/super-star-create"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Super Star Create
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/audition/star-promo-feedback"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Super Star Feedback
                  </Link>
                </div>
              </div> */}

              {/* <div className="accordion-item">
                <div className="accordion-header" id="headingFour">
                  <button
                    className="px-3 py-2 accordion-button collapsed btnAdminnav btnPromotional"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <i className="fa-solid fa-atom"></i>  &nbsp; Promotional
                    Video
                  </button>
                </div>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse  bg_black"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/promotional/video-list"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    List
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/promotional/video-create"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Create
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/promotional/accepted/video-list"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Accepted Promotional Video
                  </Link>
                </div>
              </div> */}

              <div
                className={
                  url[1] === "round-instruction-list" ||
                  url[1] === "round-instruction-create"
                    ? "cus-nav-active nav-link cursor-pointer "
                    : "cus-nav nav-link cursor-pointer"
                }
                onClick={() => setInstruction(!instruction)}
                aria-controls="example-collapse-text"
                aria-expanded={instruction}
              >
                <div className="child-cat">
                  <i className="fa-solid fa-atom"></i> &nbsp;
                </div>
                Instruction
                {instruction ? (
                  <i className="fa-solid fa-angle-up left"></i>
                ) : (
                  <i className="fa-solid fa-angle-down left"></i>
                )}
              </div>

              <Collapse in={instruction}>
                <div>
                  <Link
                    className={
                      url[1] === "round-instruction-list"
                        ? "AudAdmin-new nav-link  active-nav"
                        : "AudAdmin-new nav-link "
                    }
                    to="/audition-admin/round-instruction-list"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> &nbsp;
                    </div>
                    List
                  </Link>
                  <Link
                    className={
                      url[1] === "round-instruction-create"
                        ? "AudAdmin-new nav-link  active-nav"
                        : "AudAdmin-new nav-link "
                    }
                    to="/audition-admin/round-instruction-create"
                  >
                    <div className="child-cat">
                      <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                    </div>
                    Create
                  </Link>
                </div>
              </Collapse>

              {/* <div className="accordion-item">
                <div
                  className="accordion-header"
                  id="headingRoundVideoInstruction"
                >
                  <button
                    className="px-3 py-2 accordion-button collapsed btnAdminnav"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseRoundVideoInstruction"
                    aria-expanded="false"
                    aria-controls="collapseRoundVideoInstruction"
                  >
                    <i className="fa-solid fa-atom"></i>  &nbsp; Round
                    Instruction Video(Star)
                  </button>
                </div>
                <div
                  id="collapseRoundVideoInstruction"
                  className="accordion-collapse collapse  bg_black"
                  aria-labelledby="headingRoundVideoInstruction"
                  data-bs-parent="#accordionExample"
                >
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/round-instruction-video-list"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    List
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/round-instruction-video-create"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Create
                  </Link>
                  <Link
                    className=" AudAdmin nav-link  "
                    to="/audition-admin/round-instruction-video-accepted"
                  >
                    <div className="child-cat">
                      <i className="fa-solid fa-calendar"></i> 
                    </div>
                    Accepted
                  </Link>
                </div>
              </div> */}

              <Link
                className={
                  url[1] === "audition/filter-videos"
                    ? "AudAdmin nav-link py-3 active-nav"
                    : "AudAdmin nav-link py-3"
                }
                to="/audition-admin/audition/filter-videos"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                Filter Videos
              </Link>

              <Link
                className={
                  url[1] === "audition/distribute-videos"
                    ? "AudAdmin nav-link py-3 active-nav"
                    : "AudAdmin nav-link py-3"
                }
                to="/audition-admin/audition/distribute-videos"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                Distribute Videos
              </Link>

              <Link
                className={
                  url[1] === "audition/jury-marked-videos"
                    ? "AudAdmin nav-link py-3 active-nav"
                    : "AudAdmin nav-link py-3"
                }
                to="/audition-admin/audition/jury-marked-videos"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> &nbsp;
                </div>
                J & J Marked Videos
              </Link>

              {/* <Link
                className=" AudAdmin nav-link py-3"
                to="/audition-admin/audition/post-content-making-for-star"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-calendar"></i> 
                </div>
                Post Content Making for Star
              </Link> */}

              <Link
                className={
                  url[1] === "audition/start-approval-update"
                    ? "AudAdmin nav-link py-3 active-nav"
                    : "AudAdmin nav-link py-3"
                }
                to="/audition-admin/audition/start-approval-update"
              >
                <div className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp;
                </div>
                Approval Update
              </Link>
              <Link
                className={
                  url[1] === "audition/register-user" || url[1].startsWith("audition/participant-list")
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/register-user"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-users"></i> &nbsp;
                </div>
                Register User List
              </Link>
              <Link
                className={
                  url[1] === "audition/react-count-list" || url[1].startsWith("audition/react-count")
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/react-count-list"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-users"></i> &nbsp;
                </div>
                React Counts List
              </Link>

              <Link
                className={
                  url[1] === "audition/online-audition-round"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/online-audition-round"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-users-gear"></i> &nbsp;
                </div>
                Online User List
              </Link>

              <Link
                className={
                  url[1] === "audition/certificate-create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/audition-admin/audition/certificate-create"
              >
                <div className="child-cat">
                  <i className="fa-solid fa-certificate"></i> &nbsp;
                </div>
                Certificate
              </Link>
            </div>
          </Collapse>

          <Link
            className={
              url[1] === "profile-settings" ? "nav-link active-nav" : "nav-link"
            }
            to="/audition-admin/profile-settings"
          >
            <span className="">
              <i class="fa-solid fa-gear"></i> &nbsp; Settings
            </span>
          </Link>
        </div>
      </div>

      <Footer />
    </nav>
  );
};

export default Sidebar;
